import React from 'react';
import Image from '../../common/Image';
import { paintRBGImagePropTypes } from '../propTypes';

const PaintRGBImage = ({ asset = null, alt = '' }) => {
  if (!asset) return null;
  const rgb = asset?.rgb;
  return (
    <div
      className="sui-w-full sui-h-auto sui-aspect-square sui-max-w-full sui-flex sui-items-end"
      style={{
        backgroundColor: `rgb(${rgb?.red},${rgb?.green},${rgb?.blue})`
      }}
    >
      <Image
        alt={alt}
        src={asset?.brandLogo}
      />
    </div>
  );
};

PaintRGBImage.propTypes = paintRBGImagePropTypes;

export default PaintRGBImage;
